'use client'

import { CheckIcon } from '@radix-ui/react-icons'
import { ReactNode } from 'react'

interface PricingCardProps {
    title: string
    savings?: ReactNode
    basePrice?: ReactNode
    price: ReactNode
    billingCycle: string
    benefits: string[]
}

export const PricingCard = ({
    title,
    savings,
    basePrice,
    price,
    billingCycle,
    benefits,
}: PricingCardProps) => {
    return (
        <div className="flex w-full flex-1 flex-col gap-l rounded-2xl bg-bg-neutral-surface p-xl md:p-2xl">
            <div className="flex flex-wrap items-center justify-between gap-s">
                <h2 className="text-h4">{title}</h2>
                {savings && <p className="rounded-full bg-bg-brand p-s text-label-sm">{savings}</p>}
            </div>

            {/* Price and its billing cycle read as one unit, so they sit tighter than the rest */}
            <div className="flex flex-col gap-xs">
                {basePrice && (
                    <p className="text-p-lg text-fg-tertiary line-through">{basePrice}</p>
                )}

                <p className="text-h1 md:text-display-sm">{price}</p>

                <p className="text-p-sm md:text-p-md text-fg-secondary">{billingCycle}</p>
            </div>

            <ul className="mt-s flex flex-col gap-l">
                {benefits.map((benefit) => (
                    <li key={benefit} className="flex items-start gap-l text-p-sm md:text-p-md">
                        <CheckIcon className="size-5 shrink-0 rounded-full bg-bg-brand p-xs md:mt-xs" />
                        {benefit}
                    </li>
                ))}
            </ul>
        </div>
    )
}
